import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../Footer";

const D333 = () => {
  return (
    <div className="container" style={{ maxWidth: "80%" }}>
      <h1 className="text-center mt-4">
        WGU Course Buffet: All You Can Read 🍽️📖
      </h1>
      <Link type="button" class="btn btn-secondary" to="/courses">
        <i class="fa-solid fa-circle-arrow-left"></i> Buffet Menu
      </Link>

      <h2 className="text-center">
        You're viewing D333 - Ethics in Technology
      </h2>

      <div className="card my-4">
        <h4 className="text-center mt-4">
          WGU Course Material : <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-regular fa-star"></i>
          <i class="fa-regular fa-star"></i>
          <i class="fa-regular fa-star"></i>
        </h4>
        <h4 className="text-center my-2">Total Time Taken: 4.68 hrs</h4>
        <hr />
        <div className="card-body">
          <p>
            Easy course. I didn’t use the study material—I watched YouTube
            videos to understand the following: <br />
            <ul>
              <li>
                Consequentialism:{" "}
                <a href="https://www.youtube.com/watch?v=51DZteag74A&ab_channel=McCombsSchoolofBusiness" target="_blank" rel="noreferrer">
                  McCombs School of Business
                </a>
              </li>
              <li>
                Deontology:{" "}
                <a href="https://www.youtube.com/watch?v=wWZi-8Wji7M&ab_channel=McCombsSchoolofBusiness" target="_blank" rel="noreferrer">
                  McCombs School of Business
                </a>
              </li>
              <li>
                Utilitarianism:{" "}
                <a href="https://www.youtube.com/watch?v=-FrZl22_79Q&ab_channel=McCombsSchoolofBusiness" target="_blank" rel="noreferrer">
                  McCombs School of Business
                </a>
              </li>
              <li>
                Virtue Ethics:{" "}
                <a href="https://www.youtube.com/watch?v=NMblKpkKYao&ab_channel=McCombsSchoolofBusiness" target="_blank" rel="noreferrer">
                  McCombs School of Business
                </a>
              </li>
              <li>
                Relativism:{" "}
                <a href="https://www.youtube.com/watch?v=5RU7M6JSVtk&ab_channel=McCombsSchoolofBusiness" target="_blank" rel="noreferrer">
                  McCombs School of Business
                </a>
              </li>
              <li>
                AI Bias: <i>(so good, this one) </i>
                <a href="https://www.youtube.com/watch?v=gV0_raKR2UQ&ab_channel=CrashCourse" target="_blank" rel="noreferrer">
                  CrashCourse
                </a>
              </li>
            </ul>
            Then I went through the course material and did the mini-quizzes,
            which really helped me understand the terms better. The PA was easy,
            but I barely passed the OA. I still don’t know where my answers were
            wrong because I was pretty confident. Makes me think the questions
            need to be read carefully.
            <br />
            There were some CIA triad questions, but I had already studied that
            in a previous course, so I was good there. In summary, you really
            need to understand consequentialism, deontology, utilitarianism,
            virtue ethics, and relativism and be able to differentiate them.
            Most of my questions were about those—also, very similar to the PA.
            <br />
            <a href="/Tech_Ethics_Acronym_Glossary_highlighted.docx" download="Tech_Ethics_Acronym_Glossary_highlighted.docx">Download Notes</a>
            <br />
            Some Good Reads:
            <ul>
              <li>
                <a href="https://moderndiplomacy.eu/2021/12/24/ethical-aspects-relating-to-cyberspace-utilitarianism-and-deontology/" target="_blank" rel="noreferrer">
                  Ethical Aspects Relating to Cyberspace: Utilitarianism and
                  Deontology
                </a>
              </li>
              <li>
                <a href="https://library.fiveable.me/business-ethics-in-the-digital-age/unit-1" target="_blank" rel="noreferrer">
                  Business Ethics in the Digital Age
                </a>
              </li>
            </ul>
            Guide I used:{" "}
            <a href="https://www.reddit.com/r/WGU_CompSci/comments/19ea573/d333_ethics_in_technology_passed_10_hours/" target="_blank" rel="noreferrer">
              Reddit Post
            </a>
          </p>
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default D333;
